import * as api from "services/api";

export const GET_PIECE_TAGS = "[PIECE TAG REPORT] GET";
export const GET_PIECE_TAGS_SUCCESS = "[PIECE TAG REPORT] GET_SUCCESS";
export const GET_PIECE_TAGS_FAILED = "[PIECE TAG REPORT] GET_FAILED";
export const SET_VALUE = "[PIECE TAG REPORT] SET_VALUE";
export const CLEAR_VALUE = "[PIECE TAG REPORT] CLEAR_VALUE";

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue() {
	return {
		type: CLEAR_VALUE
	};
}

export function getPieceTagsV2(
	skip = 0,
	take = 10,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_PIECE_TAGS
		});

		const { token } = getState().login;

		let response = await api.sendGet(
			`/SaleProductTag/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_PIECE_TAGS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_PIECE_TAGS_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_PIECE_TAGS_FAILED });
			callback && callback("Erro ao carregar etiquetas");
		}
	};
}
